import dayjs from "dayjs";
import {
  BASELINE_SET_DATA,
  BASELINE_SET_FILTER,
  BASELINE_SET_LOADING,
  BASELINE_SET_SORT_BY,
} from "../actions/baseline.actions";
import { INITIALIZE_STORE } from "../actions/manager.actions";

const initialState = {
  filter: {
    date: dayjs().format("YYYY-MM-DD"),
    position: undefined,
    playerGroup: undefined,
  },
  sortBy: "last_name",
  data: [],
  loading: false,
};

export const baselineReducer = (state = initialState, action) => {
  switch (action.type) {
    case BASELINE_SET_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.payload,
        },
      };
    case BASELINE_SET_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
      };
    case BASELINE_SET_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case BASELINE_SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case INITIALIZE_STORE:
      return initialState;
    default:
      return state;
  }
};
